import { getCategory, getProductsCategory } from "../../services/Api";
import { useEffect, useState} from "react";
import { useParams } from "react-router-dom";
import ProductItem from "../../shared/components/product-item";

const Category = () => {
    const [category, setCategory]=useState({});
    const [products, setProducts]=useState([]);
    const [totalProduct, setTotalProduct]=useState(0);
    const {id} = useParams();
    useEffect(()=>{
        //get Category Details by ID
        getCategory(id, {})
        .then(({data})=>{
            // console.log(data.data);-->trả về object chứa key:value
            setCategory(data.data)})
        .catch((error)=>console.log(error));
        
        getProductsCategory(id,{})
        .then(({data})=>{
            //get Products by Category ID
            // console.log(data.data);-->trả về array chứa 10 Obj
            setProducts(data.data)
            //get Total Product
            // console.log(data.pages);-->trả về object chứa key:value
            setTotalProduct(data.pages.totalRows) })
        .catch((error)=>console.log(error));
    },[id]);
    return (
        <>
            <div>
                {/*	List Product	*/}
                <div className="products">
                    <h3>{category?.title} (hiện có {totalProduct} sản phẩm)</h3>
                    <div className="product-list card-deck">
                        {
                            products?.map((item)=>{
                                return <ProductItem item={item} />
                            })
                        }
                    </div>
                </div>
                {/*	End List Product	*/}
                <div id="pagination">
                    <ul className="pagination">
                        <li className="page-item"><a className="page-link" href="#">Trang trước</a></li>
                        <li className="page-item active"><a className="page-link" href="#">1</a></li>
                        <li className="page-item"><a className="page-link" href="#">2</a></li>
                        <li className="page-item"><a className="page-link" href="#">3</a></li>
                        <li className="page-item"><a className="page-link" href="#">Trang sau</a></li>
                    </ul>
                </div>
            </div>
        </>
    )
}
export default Category;